import { Modal, ModalBody, ModalContent, ModalHeader, ModalOverlay } from '@chakra-ui/react';
import Loading from '../../utils/Loading';
import React from 'react';

const CloningModal = ({ isOpen }) => {
	return (
		<Modal isOpen={isOpen}>
			<ModalOverlay />
			<ModalContent>
				<ModalHeader>Clonando projeto...</ModalHeader>
				<ModalBody m={6}>
					<Loading position="relative" />
				</ModalBody>
			</ModalContent>
		</Modal>
	);
};

export default CloningModal;
